import { styled } from '@mui/material/styles';

const StyledLoading = styled('div')`
  flex-grow: 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: center;
  align-items: center;
  gap: 2rem;
`;

export default StyledLoading;
